<template>
  <v-container fluid>
    <v-alert v-if="!canBeBuilt && model.statusBuild != 'built'" color="warning" dark>This club can't be built - some components missing in the Handling</v-alert>
    <v-row>
      <v-col cols="4" pa-2>
        <v-card>
          <v-card-title>Global</v-card-title>
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <v-list-item-content>Quantity:</v-list-item-content>
              <v-list-item-content class="align-end">
                {{ model.quantity }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>SST Pure:</v-list-item-content>
              <v-list-item-content class="align-end">
                {{ model.sst ? "Yes" : "No" }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="4" pa-2>
        <v-card>
          <v-card-title>Comments</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <template v-if="!model.comments || model.comments.length <= 0"
              >No comment</template
            >
            <template v-else>
              {{
                model.comments[model.comments.length - 1].user
                  .username
              }}
              ({{
                model.comments[model.comments.length - 1].timestamp
              }}) >
              <b>
                {{
                  model.comments[model.comments.length - 1].comment
                }}
              </b>
            </template>
          </v-card-text>
          <v-card-actions v-if="model.comments && model.comments.length > 0">
            <v-spacer></v-spacer>
            <v-btn @click="viewAllComment = !viewAllComment">View all</v-btn>
            <comments
              :open.sync="viewAllComment"
              :comments="model.comments"
            ></comments>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="4" pa-2>
        <v-card dark>
          <v-card-title
            >Status of build : {{ model.statusBuild ? model.statusBuild : 'unbuilt' }}</v-card-title
          >
          <v-divider></v-divider>
          <v-card-actions>
            <MarkClubAsBuilt v-if="canBeBuilt" :club="model" :handlingId="handling.id" @update="$emit('update')"/>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" pa-2>
        <v-card>
          <v-card-title>
            <h4>Head</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <v-list-item-content>Club Head:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.headProduct.name }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.headSetting">
              <v-list-item-content>Settings:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.headSetting }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.headSetting2">
              <v-list-item-content>Settings 2:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.headSetting2 }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.headLoft">
              <v-list-item-content>Loft:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.headLoft }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.headLie">
              <v-list-item-content>Lie:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.headLie }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.headStamp">
              <v-list-item-content>Stamping:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.headStamp }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.headPaintfill">
              <v-list-item-content>Paintfill:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.headPaintfill }}</b>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="4" pa-2 v-if="!model.headOnly">
        <v-card color="blue-grey darken-2" dark class="white--text">
          <v-card-title>
            <h4>SHAFT</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-list color="blue-grey darken-2">
            <v-list-item>
              <v-list-item-content>Shaft:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.shaftProduct.name }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.shaftLength">
              <v-list-item-content>Length:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.shaftLength }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.shaftCpm">
              <v-list-item-content>CPM:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.shaftCpm }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.shaftSW">
              <v-list-item-content>SW:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.shaftSW }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.shaftPaintfill">
              <v-list-item-content>Paintfill:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.shaftPaintfill }}</b>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="4" pa-2 v-if="!model.headOnly">
        <v-card>
          <v-card-title>
            <h4>Grip</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <v-list-item-content>Grip:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.gripProduct.name }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.gripExtraWraps">
              <v-list-item-content>Extra Wraps:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.gripExtraWraps }}</b>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="model.gripLogo">
              <v-list-item-content>Logo:</v-list-item-content>
              <v-list-item-content class="align-end">
                <b>{{ model.gripLogo }}</b>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Comments from "@components/prescriptions/Comments.vue";
import MarkClubAsBuilt from "./dialog/MarkClubAsBuilt.vue";

export default {
  components: {
      Comments,
      MarkClubAsBuilt
  },
  data: () =>  ({
    loading: false,
    comment: {
      form: false,
      text: null,
      action: null,
    },
    viewAllComment: false,
    mandatoryRules: [(v) => !!v || "This fiels is mandatory"],
  }),
  props: {
    item: {
      type: Object,
    },
    prescription: {
      type: Object,
    },
    build: {
      type:Object
    },
    handling: {
      type: Object,
      required: true
    }
  },
  computed:{
    model:{
      get(){
        return this.item
      },
      set(model){
        this.$emit("update", model);
      }
    },
    canBeBuilt () {
      const headAvailable = this.handling.items.findIndex(hi => hi.quantity-hi.built>0 && hi.product_id == this.model.headProductId) >= 0
      const shaftAvailable = this.handling.items.findIndex(hi => hi.quantity-hi.built>0 && hi.product_id == this.model.shaftProductId) >= 0
      const gripAvailable = this.handling.items.findIndex(hi => hi.quantity-hi.built>0 && hi.product_id == this.model.gripProductId) >= 0
      
      if(this.model.headOnly){
        return headAvailable
      }else{
        return headAvailable && shaftAvailable && gripAvailable
      }
    }
  },
  methods: {
    openComment(type) {
      this.comment.form = true;
      this.comment.action = type;
    }
  },
};
</script>

<style></style>
